import http from './http';

const create = (payload) => http.post(`/new/add`, payload);
const list = (page, expert, custom, free) =>
  http.get(`/new/list?page_size=10&page_nbr=${page}&expert=${Boolean(expert)}&custom=${Boolean(custom)}&free=${Boolean(free)}`);
const remove = (newsId) => http.del(`/new/remove/${newsId}`);
const load = (newsId) => http.get(`/new/load/${newsId}`);
const edit = (newsId, payload) => http.put(`/new/edit/${newsId}`, payload);
const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file, file?.name || 'upload.png');
  const API_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('gc_token');
  return fetch(`${API_URL}/new/add_file`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      ...(token ? { 'Authorization': token } : {})
    },
    body: formData
  }).then(async (res) => {
    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(`HTTP ${res.status}: ${text}`);
    }
    return res.json();
  });
};
const getImageUrl = (imageId) => `${process.env.REACT_APP_API_URL}/file/${imageId}`;

export default { create, list, remove, load, edit, uploadImage, getImageUrl };
export { create, list, remove, load, edit, uploadImage, getImageUrl };
